<template>

	<collapsible-panel :external-toggle="panelToggled" v-on:panelRetract="panelToggled = false">
		<template slot="panel">

			<h4>Filtering</h4>

			<field label="Filter"
				class="mr-2"
				col-class="stacked"
				v-model="timeFilter"
				:params="{type:'btn-group',buttons:[
					{text:'All',value:'all'},
					{text:'Last Year',value:12},
					{text:'Last 6 Mo.',value:6},
					{text:'Last 3 Mo.',value:3},
				]}"
				v-on:change="fetchAcknowledgements(true)">
			</field>

			<field label="Library Document"
				col-class="stacked"
				v-model="documentFilter"
				:params="{type:'select',options:documentOptions}"
				v-on:change="libraryFileSelected">
			</field>
		</template>

		<template slot="main">

			<freemium-locked-alert v-if="$store.company.is_freemium == 1"></freemium-locked-alert>

			<h2>Library Acknowledgements for {{ $store.employee.first_name }} {{ $store.employee.last_name }}</h2>

			<table-list
				record-name="Acknowledgement"
				:fields="fields"
				:records="mutatedAcknowledgements"
				:sortable="true"
				:hide-record-count="true">

				<button :disabled="panelToggled" class="btn btn-light" v-on:click="panelToggled = true">
					<i class="fa fa-filter"></i>
					Filter
				</button>

			</table-list>
		</template>
	</collapsible-panel>

</template>
<script type="text/javascript">
import TableList from "@/components/TableList"
import Field from "@/components/Field"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import FreemiumLockedAlert from "@/components/FreemiumLockedAlert"


export default  {
	name: "EmployeeLibraryAcknowledgements",
	components: {
		TableList,
		Field,
		CollapsiblePanel,
		FreemiumLockedAlert
	},
	props: ["blockFetches"],
	data() {
		return {
			acknowledgements: [],
			documents: [],
			timeFilter: 12,
			documentFilter: false,
			panelToggled: false,
			fields: [
				{label: "Acknowledgement Date/Time",key: "ackDateTime"},
				{label: "Document Filename",key:"filename"},
				{label: "Document Caption",key:"caption"}
			]
		}
	},
	watch: {
		blockFetches() {
			if (!this.blockFetches) {
				this.fetchData()
			}
			
		}
	},
	computed: {
		documentOptions() {
			return this.optionify(this.documents.map(doc => {
				doc.display = ""

				if (doc.UploadFile)
					doc.display = doc.UploadFile.original_filename
				else if (doc.caption != '')
					doc.display = doc.caption

				return doc

			}),"display")
		},
		mutatedAcknowledgements() {
			let vm = this

			return this.acknowledgements.map(ack => {
				ack.ackDateTime = vm.formatDateTimeToLocal(ack.acknowledgement_datetime)

				ack.filename = ""
				if (ack.LibraryFile && ack.LibraryFile.UploadFile) {
					ack.filename = ack.LibraryFile.UploadFile.original_filename
				}

				ack.caption = ""
				if (ack.LibraryFile)
					ack.caption = ack.LibraryFile.caption

				return ack
			})
		}
	},
	methods: {
		libraryFileSelected() {
			let vm = this

			this.$nextTick(() => {
				vm.fetchAcknowledgements(true)
			})
		},
		fetchData() {
			let vm = this

			let promises = [
				this.getJSON("LibraryFile/get",{include:[{model:"UploadFile",fields:["id","original_filename"]}]}),
				this.fetchAcknowledgements(false)
			]

			Promise.all(promises).then(responses => {
				vm.documents = responses[0].data
			})
		},
		fetchAcknowledgements(spinner) {
			let vm = this

			let filters = [
				["user_id",this.$store.employee.id]
			]

			if (typeof this.timeFilter == 'number') {
				//calculate date of x months ago 

				let ago = this.moment().subtract(this.timeFilter,"months").format("YYYY-MM-DD")

				filters.push(["acknowledgement_datetime >",ago])
			}

			if (this.documentFilter)
				filters.push(["library_file_id",this.documentFilter])

			let params = {
				filters: filters,
				include: [{model:"LibraryFile",include:["UploadFile"]}]
			}

			if (spinner)
				vm.spinner(true)

			return new Promise((resolve,reject) => {
				vm.getJSON("LibraryAcknowledgement/get",params,true).then(response => {

					if (spinner)
						vm.spinner(false)

					if (response.success) {
						vm.acknowledgements = response.data
					}

					resolve(response)
				})
			})

		}
	},
	created() {
		if (!this.blockFetches)
			this.fetchData()
	}
}
</script>